import { Helmet } from "react-helmet-async";
import {
  /*Breadcrumb, BreadcrumbItem,*/ Button,
  Col,
  Container,
  Jumbotron,
  Row,
} from "reactstrap";
import {
  IMAGE_URL,
  SITE_DESCRIPTION,
  SITE_KEYWORD,
  SITE_NAME,
  SITE_URL,
} from "../../config/Config";

const ErrorLoadingPage = () => {
  const title = "خطا در بارگذاری محتوا";

  return (
    <div className="user-portal-pages">
      <Helmet
        title={`${title} | ${SITE_NAME}`}
        meta={[
          { name: "description", content: SITE_DESCRIPTION },
          { name: "keyword", content: SITE_KEYWORD },
          { property: "og:type", content: "article" },
          { property: "og:title", content: title },
          {
            property: "og:image",
            content: `${IMAGE_URL}uploads/apple-touch-icon.png`,
          },
          { property: "og:url", content: SITE_URL },
        ]}
      />
      <Jumbotron className="rtl">
        <Container>
          <Row className="mw-1100 m-auto equal">
            <Col>
              <h1 className="page-title text-black mt-5 pt-3">{title}</h1>
              <br />
              {/* <Breadcrumb tag="nav" listTag="div" className="page-breadcrumb text-black pt-3">
                                <BreadcrumbItem tag="a" href="/">خانه</BreadcrumbItem>
                                <BreadcrumbItem active tag="span">{title}</BreadcrumbItem>
                            </Breadcrumb> */}
            </Col>
          </Row>
        </Container>
      </Jumbotron>
      <div className="container pt-5 mt-3 rtl">
        <div className="row">
          <div className="col-sm-12" style={{ minHeight: 400 }}>
            <br />
            <br />
            <br />
            <h3 className="text-block text-center">
              خطا در هنگام دریافت محتوا ...
            </h3>
            <p className="text-block-50 text-center">
              لطفا اتصال خود به اینترنت را چک کنید
            </p>
            <p className="text-center m-5">
              <Button
                color="danger"
                className="btn-reds1"
                size="lg"
                onClick={() => window.location.reload()}
              >
                تلاش مجدد !
              </Button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorLoadingPage;
